import React from 'react'
// import PropTypes from 'prop-types';

import { 
  MainTitle, Subtitle,
  TextContent, HighlightText,
  JsonCodeStyle,
} from '../../../Shared';

import { StyledSeparated } from '../FindNearSegments/FindNearSegments.styled';

const References = props => {
  const responseSuccess = {
    "code": 200,
    "message": "success",
    "data": [
      {
        "_id": "5dca2a12bfe2ed2794c87864",
        "name": "Tắc đường",
        "group": "traffic_report_cause",
        "createdAt": "2019-11-12T03:42:10.463Z",
        "updatedAt": "2019-11-12T03:42:10.463Z",
        "__v": 0
      },
      {
        "_id": "5dca2a1abfe2ed2794c87865",
        "name": "Ngập lụt",
        "group": "traffic_report_cause",
        "createdAt": "2019-11-12T03:42:18.154Z",
        "updatedAt": "2019-11-12T03:42:18.154Z",
        "__v": 0
      },
      {
        "_id": "5dca2a23bfe2ed2794c87866",
        "name": "Có vật cản",
        "group": "traffic_report_cause",
        "createdAt": "2019-11-12T03:42:27.903Z",
        "updatedAt": "2019-11-12T03:42:27.903Z",
        "__v": 0
      },
      {
        "_id": "5dca2a2fbfe2ed2794c87867",
        "name": "Tai nạn",
        "group": "traffic_report_cause",
        "createdAt": "2019-11-12T03:42:39.391Z",
        "updatedAt": "2019-11-12T03:42:39.391Z",
        "__v": 0
      },
      {
        "_id": "5dca2a36bfe2ed2794c87868",
        "name": "Công an",
        "group": "traffic_report_cause",
        "createdAt": "2019-11-12T03:42:46.169Z",
        "updatedAt": "2019-11-12T03:42:46.169Z",
        "__v": 0
      },
      {
        "_id": "5dca2a3dbfe2ed2794c87869",
        "name": "Đường cấm",
        "group": "traffic_report_cause",
        "createdAt": "2019-11-12T03:42:53.766Z",
        "updatedAt": "2019-11-12T03:42:53.766Z",
        "__v": 0
      },
      {
        "_id": "5dca6f4e3f1f1637f856271a",
        "group": "update-status-interval",
        "key": null,
        "value": "60000",
        "createdAt": "2019-11-12T08:37:34.691Z",
        "updatedAt": "2020-08-02T23:55:43.017Z",
        "__v": 0,
        "name": null
      }
    ]
  }

  return (
    <div>
      <MainTitle>References</MainTitle>
      <TextContent>Get all configs of system such as: reasons, status interval</TextContent>
      <Subtitle id="request-references">Request</Subtitle>
      <TextContent><b><i>URI: </i></b><HighlightText>/api/reference/get-all</HighlightText> </TextContent>
      <TextContent><b><i>Method: </i></b>@GET</TextContent>
      <TextContent><b><i>Query params:</i></b> No params</TextContent>

      <Subtitle id="response-direct">Response</Subtitle>
      <Subtitle isSmall id="success-direct">Success</Subtitle>
      <JsonCodeStyle data={responseSuccess} />
      <StyledSeparated />
    </div>
  )
}

References.propTypes = {

}

export default References
